export default "__VITE_ASSET__upMvOI2c__"